// About panel: build version and the registered features. Also the smallest
// example of a feature: this file is all it takes to add one.

import { defineFeature, features } from "../../registry";
import buildInfo from "../../generated/build-info.json";

export default defineFeature({
  id: "about",
  title: "About",
  slot: "panel",
  order: 1000,
  mount({ root }) {
    const list = document.createElement("dl");
    const rows: [string, string][] = [
      ["Version", buildInfo.version],
      ["Commit", buildInfo.commit],
      ["Built", buildInfo.builtAt],
      ["Features", features.map((f) => f.id).join(", ")],
    ];
    for (const [term, value] of rows) {
      const dt = document.createElement("dt");
      dt.textContent = term;
      const dd = document.createElement("dd");
      dd.textContent = value;
      list.append(dt, dd);
    }
    root.append(list);
  },
});
